import React from 'react';
import { SidebarLayout } from './layout/SidebarLayout';
import { SelectionPanel } from './panels/SelectionPanel';
import { ToolsPanel } from './panels/ToolsPanel';
import { UtilitiesPanel } from './panels/UtilitiesPanel';
import { InteractionConstraint } from '../../ui/InteractionConstraint/InteractionConstraints';
import { Tab } from '../../app_data/Tab';
import { RnaComplexProps, UndoRedoStack } from '../../App';
import type { VisibilityEntry } from '../../utils/Visibility';

export interface SidebarProps {
  constraint?: InteractionConstraint.Enum;
  onConstraintChange?: (constraint: InteractionConstraint.Enum) => void;
  mode?: Tab;
  onModeChange?: (mode: Tab) => void;
  onUndo?: () => void;
  onRedo?: () => void;
  canUndo : boolean;
  canRedo : boolean;
  onResetViewport?: () => void;
  onToggleBasePairEditor?: () => void;
  onTogglePropertiesDrawer?: () => void;
  onToggleSettingsDrawer?: () => void;
  onToggleAboutDrawer?: () => void;
  onOpenDocs?: () => void;
  onReformatAll?: () => void;
  undoStack?: UndoRedoStack;
  redoStack?: UndoRedoStack;
  onJumpToHistory?: (index: number) => void;
  onResetToLastCheckpoint?: () => void;
  onFreezeSelected?: () => void;
  onUnfreezeSelected?: () => void;
  onUnfreezeAll?: () => void;
  hasFrozenNucleotides?: boolean;
  hasSelectedNucleotides?: boolean;
  rnaComplexProps: RnaComplexProps;
  visibilityEntries: Array<VisibilityEntry>;
  onToggleVisibilityEntry: (id: string) => void;
  onRemoveVisibilityEntry: (id: string) => void;
  onShowAll: () => void;
}

export const Sidebar: React.FC<SidebarProps> = (props) => {
  const {
    constraint, onConstraintChange, mode, onModeChange,
    onUndo, onRedo, canUndo, canRedo, onResetViewport,
    onToggleBasePairEditor, onTogglePropertiesDrawer,
    onToggleSettingsDrawer, onToggleAboutDrawer,
    onOpenDocs, onReformatAll,
    undoStack, redoStack, onJumpToHistory, onResetToLastCheckpoint,
    onFreezeSelected, onUnfreezeSelected, onUnfreezeAll,
    hasFrozenNucleotides, hasSelectedNucleotides,
  } = props;

  return (
    <SidebarLayout>
      <SelectionPanel constraint={constraint} onConstraintChange={onConstraintChange} rnaComplexProps={props.rnaComplexProps} />
      <ToolsPanel mode={mode || Tab.EDIT} 
        onModeChange={onModeChange} onUndo={onUndo} onRedo={onRedo} canUndo = {canUndo} canRedo = {canRedo} onResetViewport={onResetViewport} undoStack={undoStack}
        redoStack={redoStack}
        onJumpToHistory={onJumpToHistory}
        onResetToLastCheckpoint={onResetToLastCheckpoint}
        constraint={constraint}
        onFreezeSelected={onFreezeSelected}
        onUnfreezeSelected={onUnfreezeSelected}
        onUnfreezeAll={onUnfreezeAll}
        hasFrozenNucleotides={hasFrozenNucleotides}
        hasSelectedNucleotides={hasSelectedNucleotides}
        rnaComplexProps={props.rnaComplexProps}
        visibilityEntries={props.visibilityEntries}
        onToggleVisibilityEntry={props.onToggleVisibilityEntry}
        onRemoveVisibilityEntry={props.onRemoveVisibilityEntry}
        onShowAll={props.onShowAll}
      />
      
      <UtilitiesPanel
        onToggleBasePairEditor={onToggleBasePairEditor}
        onTogglePropertiesDrawer={onTogglePropertiesDrawer}
        onToggleSettingsDrawer={onToggleSettingsDrawer}
        onToggleAboutDrawer={onToggleAboutDrawer}
        onOpenDocs={onOpenDocs}
        onReformatAll={onReformatAll}
      />
    </SidebarLayout>
  );
}; 